import styled from 'styled-components';

import { basicTitleTextStyle, fonts } from '@dreryk/react-components';

type StyledFormSectionHeaderProps = {
   fontWeight?: number;
};

// Some global style is overwriting margin
export const StyledFormSectionHeader = styled.h3<StyledFormSectionHeaderProps>`
   margin: 0 !important;
   ${basicTitleTextStyle}
   color: ${(props) => props.theme.borderDarker};
   font-weight: ${(props) => props.fontWeight ?? fonts.fontWeightNormal};
`;

StyledFormSectionHeader.displayName = 'StyledFormSectionHeader';
